import { defineMessages } from 'react-intl';

export default defineMessages({
    editDebitCardTitle: {
        id: '_.edit_debit_card_title',
        defaultMessage: 'Card ●●●● {cardNumber}'
    },
    deletePaymentMethod: {
        id: '_.edit_debit_card.delete_payment_method',
        defaultMessage: 'Delete payment method'
    },
    deleteConfirmation: {
        id: '_.edit_debit_card.delete_confirmation',
        defaultMessage: 'Are you sure?'
    },
    confirmAction: {
        id: '_.edit_debit_card.confirm_action',
        defaultMessage: 'Yes'
    },
    cancelAction: {
        id: '_.edit_debit_card.cancel_action',
        defaultMessage: 'No'
    },
    cardNumber: {
        id: '_.edit_debit_card.card_number',
        defaultMessage: 'Card number'
    },
    expiryDate: {
        id: '_.edit_debit_card.expiry_date',
        defaultMessage: 'Expiry date'
    },
    CVV: {
        id: '_.edit_debit_card.cvv',
        defaultMessage: 'CVC'
    },
    billingPostcode: {
        id: '_.edit_debit_card.billing_postcode',
        defaultMessage: 'Billing postcode'
    },
    automaticRepayments: {
        id: '_.edit_debit_card.automatic_repayments',
        defaultMessage: 'Take repayments automatically?'
    }
});
